var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeggrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 16,
    viewBox: "0 0 10 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4 14C4 15.1 3.09 16 2 16C0.9 16 0 15.1 0 14C0 12.89 0.9 12 2 12C3.09 12 4 12.89 4 14ZM2 6C0.9 6 0 6.89 0 8C0 9.1 0.9 10 2 10C3.09 10 4 9.1 4 8C4 6.89 3.09 6 2 6ZM2 0C0.9 0 0 0.89 0 2C0 3.1 0.9 4 2 4C3.09 4 4 3.1 4 2C4 0.89 3.09 0 2 0ZM8 4C9.09 4 10 3.1 10 2C10 0.89 9.09 0 8 0C6.9 0 6 0.89 6 2C6 3.1 6.9 4 8 4ZM8 6C6.9 6 6 6.89 6 8C6 9.1 6.9 10 8 10C9.09 10 10 9.1 10 8C10 6.89 9.09 6 8 6ZM8 12C6.9 12 6 12.89 6 14C6 15.1 6.9 16 8 16C9.09 16 10 15.1 10 14C10 12.89 9.09 12 8 12Z",
    fill: "#5E5C71",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeggrid);
export default __webpack_public_path__ + "static/media/seggrid.b64ec89b0d5d80caa216ab35be030787.svg";
export { ForwardRef as ReactComponent };